module.exports = require("@swa-ui/core/src/Adjoin/Adjoin.module.scss");